import { render } from "./ViewMoreDocuments.vue?vue&type=template&id=3d158522&scoped=true&ts=true&lang=pug"
import script from "./ViewMoreDocuments.vue?vue&type=script&lang=ts"
export * from "./ViewMoreDocuments.vue?vue&type=script&lang=ts"

import "./ViewMoreDocuments.vue?vue&type=style&index=0&id=3d158522&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d158522"]])

export default __exports__